import { types } from 'mobx-state-tree'

const AudienceListCreation = types.model('AudienceListCreation', {
  id: types.identifierNumber,
  name: types.string
})

export type IAudienceListCreation = typeof AudienceListCreation.Type
export default AudienceListCreation
